import { ContentView } from "../../components/content-view/ContentView";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import SummaryListingViewContent from "../../components/summary-listing/SummaryListingViewContent";


export default function SummaryListingView() {
    
    const routeContext = useRouteContext();

    return (
        <ContentView>

            <SummaryListingViewContent
                groupID={routeContext.groupID as number}
                contextObject={routeContext.contextObject!}
                configurationID={routeContext.state?.configurationID}
            
            />

        </ContentView>
    );
}
